// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hrxK","colBig":"styles_colBig__2wpEh","colSmall":"styles_colSmall__3Sqn0"};